import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "w-full h-24 bg-white flex items-start justify-between border-b fixed border-brand z-30 -md:h-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-end mr-4 -md:hidden"
}
const _hoisted_4 = { class: "text-gray-900 font-semibold text-right truncate leading-loose" }
const _hoisted_5 = { class: "flex flex-col items-center justify-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "hidden -md:block text-center text-xs text-gray-900 font-semibold truncate leading-none pb-1 mt-0.5"
}
const _hoisted_10 = {
  key: 0,
  class: "px-3 py-2 border-b border-gray-300 space-y-1"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-semibold text-gray-900 truncate mb-1" }, "Logado como:", -1)
const _hoisted_12 = { class: "font-medium" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "leading-none mb-px" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "leading-none mb-px" }, "Sair", -1)
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "leading-none mb-px" }, "Sair", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["w-full h-24 flex items-center justify-between transition-all duration-500 p-6 -md:py-4 -md:h-16", `${this.haveSidebar && !this.isSidebarCollapsed && 'ml-64 -lg:ml-24 -md:ml-0'} ${
        this.haveSidebar && this.isSidebarCollapsed && 'ml-24 -md:ml-0'
      }`])
    }, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_2, [
        (this.displayName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(this.getDisplayName()), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Menu, {
          as: "div",
          class: "relative inline-block text-left"
        }, {
          default: _withCtx(({ open }) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_MenuButton, { class: "pt-1 inline-flex justify-center rounded-full hover:filter hover:brightness-75 focus:outline-none" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass([`${open && 'border-gray-900'}`, "inline-block h-12 w-12 rounded-full border border-gray-400 hover:border-gray-900 overflow-hidden transition duration-200 -md:h-8 -md:w-8"])
                  }, [
                    (_ctx.avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          alt: "",
                          src: _ctx.avatar,
                          class: "avatar h-full w-full transition duration-200"
                        }, null, 8, _hoisted_6))
                      : (_openBlock(), _createElementBlock("svg", {
                          key: 1,
                          class: _normalizeClass([`${open && 'active'}`, "avatar h-full w-full transition duration-200"]),
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, _hoisted_8, 2))
                  ], 2)
                ]),
                _: 2
              }, 1024),
              (this.displayName)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(this.getDisplayNameMobile()), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-y-95",
              "enter-to-class": "transform opacity-100 scale-y-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-y-100",
              "leave-to-class": "transform opacity-0 scale-y-95"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuItems, { class: "origin-top-right absolute right-0 mt-2 w-72 rounded-lg shadow-xl bg-white border border-gray-300 focus:outline-none" }, {
                  default: _withCtx(() => [
                    (_ctx.userData)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _hoisted_11,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData, (value, name, index) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: index,
                              class: "text-sm text-gray-900 leading-snug truncate"
                            }, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(name) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(value), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.additionalButtons)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalButtons, (button, index) => {
                            return (_openBlock(), _createBlock(_component_MenuItem, { key: index }, {
                              default: _withCtx(({ active }) => [
                                _createElementVNode("button", {
                                  class: _normalizeClass([
                      active && 'bg-gray-300',
                      'group flex items-center h-12 w-full px-3 py-2 text-gray-900 text-sm -md:h-16',
                    ]),
                                  onClick: button.function
                                }, [
                                  (button.icon)
                                    ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                        key: 0,
                                        class: "mr-2",
                                        icon: button.icon
                                      }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(button.label), 1)
                                ], 10, _hoisted_14)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_MenuItem, null, {
                            default: _withCtx(({ active }) => [
                              _createElementVNode("button", {
                                class: _normalizeClass([
                      active && 'bg-gray-300',
                      !_ctx.userData && 'rounded-t-lg',
                      'group flex items-center h-12 w-full px-3 py-2 text-gray-900 text-sm rounded-b-lg -md:h-16',
                    ]),
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logOutFunction && _ctx.logOutFunction(...args)))
                              }, [
                                _createVNode(_component_FontAwesomeIcon, {
                                  class: "mr-2",
                                  icon: _ctx.logOutIcon
                                }, null, 8, ["icon"]),
                                _hoisted_16
                              ], 2)
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_MenuItem, null, {
                            default: _withCtx(({ active }) => [
                              _createElementVNode("button", {
                                class: _normalizeClass([
                      active && 'bg-gray-300',
                      !_ctx.userData && 'rounded-t-lg',
                      'group flex items-center h-12 w-full px-3 py-2 text-gray-900 text-sm rounded-b-lg',
                    ]),
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logOutFunction && _ctx.logOutFunction(...args)))
                              }, [
                                _createVNode(_component_FontAwesomeIcon, {
                                  class: "mr-2",
                                  icon: _ctx.logOutIcon
                                }, null, 8, ["icon"]),
                                _hoisted_18
                              ], 2)
                            ]),
                            _: 1
                          })
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}